<template>
  <div>
    <input
      type="text"
      @input="search($event.target.value)"
      v-model="company_name"
      placeholder="הקלד/י חברה..."
    />
    <div
      v-if="companies_search_results.length > 0 && companies_search_results[0] != undefined"
      class="search_results"
    >
      <div
        style="margin: 0;"
        :key="'company_' + (company == undefined ? '0' : company.id)"
        @click="selectCompany(company)"
        v-for="company in companies_search_results"
      >
        <div v-if="company != undefined" class="search_result flex flex_align_center flex_justify_between">
          {{ company.is_create ? "צור חדש" : company.name }}
          <div v-if="is_creating" class="loading"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'companies-search-box',
  props: ['selected_company_name'],
  data () {
    return {
      companies_search_results: [],
      company_name: this.selected_company_name == undefined ? '' : this.selected_company_name,
      is_creating: false
    }
  },
  methods: {
    search (keyword) {
      if (keyword.length == 0) {
        this.companies_search_results = []
        return
      }
      this.$network_utils.searchCompany(keyword).then(response => {
        this.companies_search_results = response
        let is_show_create = response.length == 1 && (response[0] == undefined || response[0].name == 'אחר')
        if (is_show_create) {
          this.companies_search_results = [{
            name: keyword,
            is_create: true,
            id: 0
          }]
        }
      })
    },
    selectCompany (company) {
      if (company.is_create) {
        this.createCompany(company)
        return
      }
      this.company_name = company.name
      this.companies_search_results = []
      this.$emit('input', company.id)
      this.$emit('selected', company)
    },
    createCompany (company) {
      this.is_creating = true
      this.$network_utils.postCompany({ name: company.name }).then((response) => {
        this.selectCompany(response)
        this.is_creating = false
      })
    }
  }
}
</script>
